<template>
  <div>
    <PageTitle titleText="イベント一覧" />
    <div>
      <div class="mainContentBoxInner eventrsv eventindex">
        <div class="preview-index">
          <div class="reserve">
            <div
              v-for="(preview, index) in previews"
              :key="`preview_${index}`"
              class="collapse flex-col"
              @click="openEvent(preview)"
            >
              <div class="title">
                <div class="rsvtitle">{{ preview.title }}</div>
                <div class="totalcapacity">
                  {{
                    preview.totalCapacity - preview.reserved > 0
                      ? " （○空きあり）"
                      : " （✕空きなし）"
                  }}
                </div>
              </div>
              <div
                class="application-range"
                v-if="preview.applicationRange != null"
              >
                <div>
                  申込期間：{{
                    $date(preview.applicationRange[0]).tz().format("YYYY-MM-DD HH:mm")
                  }}〜{{
                    $date(preview.applicationRange[1]).tz().format("YYYY-MM-DD HH:mm")
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PreviewSrevice from "../../../services/preview.service";
import PreviewReserveService from "../../../services/preview-reserve.service";
import PageTitle from "@/components/PageTitle.vue";
export default {
  components: {
    PageTitle,
  },
  data() {
    return {
      isReserved: false,
      previews: [],
      reservedData: {},
    };
  },
  async created() {
    await this.reloadData();
  },
  methods: {
    openEvent(preview) {
      console.log("openEvent");
      console.log(preview);
      if (preview.applicationRange == null) {
        this.$router.push({
          name: "mc-event-detail",
          params: { previewid: preview._id },
        });
        return;
      }
      if (
        this.$date().isBetween(
          preview.applicationRange[0],
          preview.applicationRange[1],
          null,
          "[]",
        )
      ) {
        this.$router.push({
          name: "mc-event-detail",
          params: { previewid: preview._id },
        });
      } else {
        this.$message.error("申込期間外です");
      }
    },
    async reloadData() {
      this.isExistReserve();
      const res = await PreviewSrevice.findWithReserve("");
      console.log(res.data);
      this.previews = res.data;
    },
    onUpdate() {},
    async onCancel() {
      if (confirm("キャンセルしても良いですか？")) {
        console.log("onCancel");
        const res = await PreviewReserveService.remove(this.reservedData._id);
        console.log(res);
        this.$message.success("キャンセルしました");
        this.reloadData();
      }
    },
    async isExistReserve() {
      const res = await PreviewReserveService.findv2({
        where: {
          mansion: this.currentUser.mansion.id,
          roomNo: this.currentUser.roomNo,
        },
        option: {
          populate: "preview",
        },
      });
      console.log("isExistReserve", res);
      this.isReserved = res.data.length > 0;
      if (this.isReserved) {
        this.reservedData = {};
        const previewReserve = res.data[0];
        console.log("previewReserve", previewReserve);
        const preview = res.data[0].preview;
        this.reservedData.title = preview.title;
        this.reservedData.date =
          preview.schedules[previewReserve.scheduleIndex].date;
        this.reservedData.start =
          preview.schedules[previewReserve.scheduleIndex].komas[
            previewReserve.komaIndex
          ].start;
        this.reservedData.end =
          preview.schedules[previewReserve.scheduleIndex].komas[
            previewReserve.komaIndex
          ].end;
        this.reservedData._id = previewReserve._id;
      }
    },
    onReserve(previewid, scheduleIndex, komaIndex, nokori) {
      console.log(
        `onReserve_${previewid}_${scheduleIndex},${komaIndex}_${nokori}`,
      );
      if (nokori > 0) {
        this.$router.push({
          name: "mc-preview-reserve",
          params: { previewid, scheduleIndex, komaIndex },
        });
      }
    },
  },
};
</script>

<style scoped>
.flex-col {
  display: flex;
  flex-direction: column;
}

.application-range {
  font-size: 12px;
}

.preview-index {
  font-size: 14px;
}

.koma-parent {
  margin-left: 20px;
}

.koma-item {
  display: flex;
  flex-direction: row;
}
</style>
